(function ($) {
    $(document).ready(function () {
        //console.log('storypage init');
        function ResizeStoryFrame() {
            //console.log("resizing story iframe");
            var frameHeight = $(window).height() - $('#mainMenu').height() - $('header.header').height() - 10;
            //console.log(frameHeight);
            document.getElementById('storyframe').height = frameHeight;
        }
        if ($('#storyframe').length > 0) {
            $('#storyframe').on('load', function () { ResizeStoryFrame(); });
            $(window).resize(function () { ResizeStoryFrame(); });
        }
    });
})(jQuery);


(function ($) {
    $(document).ready(function () {
        //console.log('storypagecontent init');
        function ResizeStoryContentFrame() {
            //console.log("resizing story content iframe");

            //var $mainMenu = $('#mainMenu');
            //var mainMenuHeight = $mainMenu.length ? $mainMenu.outerHeight(true) : 0;
            ////console.log('mainMenuHeight ' + mainMenuHeight);

            //var $header = $('header.header');
            //var headerHeight = $header.length ? $header.outerHeight(true) : 0;
            ////console.log('headerHeight ' + headerHeight);

            //var $topContent = $('#top-content');
            //var topContentHeight = $topContent.length ? $topContent.outerHeight(true) : 0;
            ////console.log('topContentHeight ' + topContentHeight);

            //var $bottomContent = $('#bottom-content');
            //var bottomContentHeight = $bottomContent.length ? $bottomContent.outerHeight(true) : 0;
            ////console.log('bottomContentHeight ' + bottomContentHeight);

            //var frameHeight = $(window).height()
            //    - mainMenuHeight - headerHeight
            //    - topContentHeight - bottomContentHeight
            //    - 10;

            // Set frame height to full window, rather than shrinking to available height.
            var frameHeight = $(window).height() - 10;

            //console.log('frameHeight ' + frameHeight);

            //document.getElementById('storycontentframe').height = frameHeight;
            $('#storycontentframe').css('height', frameHeight + 'px');
        }

        var $iframe = $('#storycontentframe');
        if ($iframe.length === 0) {
            return; 
        }

        $iframe.on('load', function () { ResizeStoryContentFrame(); });
        $(window).resize(function () { ResizeStoryContentFrame(); });

        ResizeStoryContentFrame();

    });
})(jQuery);